export const DESIGN_MODES = {
  COLLAGES: 'COLLAGES',
  SAVE_THE_DATE: 'SAVE_THE_DATE',
};
